import React, { useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faMobileAlt, faChartLine, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import '../Projects.css';

const Projects = ({ projectRefs }) => {
  const projects = [
    {
      id: 1,
      title: 'Howmies App',
      description: 'A group project lifestyle management app connecting users with home service providers. Contributed as a Frontend Developer, building responsive UI components with React and Tailwind CSS, integrating with backend APIs, and participating in team sprints to resolve bugs and improve performance.',
      icon: faMobileAlt,
      technologies: ['React', 'Tailwind CSS', 'API Integration'],
      liveUrl: '#',
      githubUrl: '#'
    },
    {
      id: 2,
      title: 'Newsflash Website',
      description: 'A news platform designed and developed using HTML, CSS, and JavaScript to display the latest news. Features responsive design and real-time news updates.',
      icon: faChartLine,
      technologies: ['HTML', 'CSS', 'JavaScript'],
      liveUrl: '#',
      githubUrl: 'https://github.com/uchie333/Newsflash'
    },
    {
      id: 3,
      title: 'Todo Application',
      description: 'A fully functional task management app built with React, Node.js, Express.js, and SQLite. Features user authentication, complete CRUD operations for tasks, and a responsive interface.',
      icon: faCode,
      technologies: ['React', 'Node.js', 'Express.js', 'SQLite'],
      liveUrl: '#',
      githubUrl: 'https://github.com/uchie333/Todo-Application'
    },
    {
      id: 4,
      title: 'Recipe Website',
      description: 'A dynamic culinary application developed using React to showcase a variety of traditional and modern recipes. Features responsive UI components built with custom CSS modules and structured navigation system for organized recipe management.',
      icon: faMobileAlt,
      technologies: ['React', 'CSS Modules', 'Vercel'],
      liveUrl: 'https://new-recipe-one.vercel.app/',
      githubUrl: 'https://github.com/uchie333/New-Recipe'
    }
  ];

  useEffect(() => {
    // Set refs for project cards
    projectRefs.current = projectRefs.current.slice(0, projects.length);
  }, [projectRefs, projects.length]);

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2 className="section-title">Featured Projects</h2>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div 
              key={project.id} 
              className="project-card"
              ref={el => projectRefs.current[index] = el}
            >
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tech">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
                <div className="project-links">
                  {project.liveUrl !== '#' && (
                    <a 
                      href={project.liveUrl} 
                      className="project-link"
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faExternalLinkAlt} /> Live Demo
                    </a>
                  )}
                  {project.githubUrl !== '#' && (
                    <a 
                      href={project.githubUrl} 
                      className="project-link"
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faGithub} /> Code
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
